<div>
  <formatted-address
    [address]="address"
    [reducedFormat]="reducedFormat"
    [isAssignmentEncrypted]="isAssignmentEncrypted"
  >
  </formatted-address>
</div>

<div class="right">
  <div><ng-content select="[buttons]"></ng-content></div>

  @if (!isAssignmentEncrypted) {
  <div class="map-link">
    <untrusted-link
      [href]="address | gMapLink"
      (click)="$event.stopPropagation()"
    >
      <icon type="geo-alt-fill"></icon>
    </untrusted-link>
  </div>
  }
</div>
